import styled from 'styled-components';


export const Banner = styled.div`
	width: 100%;
	max-height: 345px;
	height: 50vw;
	min-height: 300px;
	background-size: cover;
	background-repeat: no-repeat;
	padding: 35px;
	border-radius: 6px;
	max-width: 800px;
	justify-self: center;
	
	&:first-child {
		background-position: 100% 100%;
		>.content {
			margin-left: auto;
			margin-right: 0;
		}
	}


	&:last-child {
		>.content {
			margin-left: 0;
			margin-right: auto;
		}
	}
	
	> .content {
		flex-flow: column;
		align-items: center;
		justify-content: space-between;
		height: 100%;
		max-width: 310px;
		width: 100;
		display: flex;
		
		.title {
			color: #001644;

			text-align: center;
			font-size: 25px;
			margin-bottom: 0;
			font-style: normal;
			font-weight: 800;
			line-height: normal;
			text-transform: uppercase;
		}
		
		.description {
			color: #001644;
			max-width: 245px;

			text-align: center;
			font-size: 20px;
			font-style: normal;
			font-weight: 600;
		}
		
	}
	
	@media all and (min-width: 1024px) {
		max-height: 330px;
		height: 27vw;
	}
`
export const GridLayout = styled.div`
	display: grid;
	grid-template-columns: auto;
	grid-template-rows: auto;
	grid-gap: 14px;
	
	@media all and (min-width: 1024px) {
		grid-template-columns: 1fr 1fr;
	}
`
